import script from "./VAFormTransfer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VAFormTransfer.vue?vue&type=script&setup=true&lang=ts"

import "./VAFormTransfer.vue?vue&type=style&index=0&id=4f59f8a0&lang=css"

const __exports__ = script;

export default __exports__